module.exports = __webpack_public_path__ + "static/media/More details (Active).9833ab99.svg";